/* eslint-disable */
<template>
  <b-container fluid>
    <b-row>
      <b-col lg="12">
        <iq-card class="px-3 py-3">
          <template v-slot:body>
            <p v-if="!propOpenedInModal">{{ cvCardTitle }}</p>
            <form action="#">
              <div class="form-row">
                <!-- Agent ID -->
                <div class="col-md-12 mb-3">
                  <label>{{ cvAgentIdLabel }}</label>
                  <input style="cursor: not-allowed;" disabled v-model="vmWrkAgentFormData.agent_id" type="text" class="form-control" readonly/>
                </div>

                <!-- Agent Name -->
                <div class="col-md-12 mb-3">
                  <label>{{ cvAgentNameLabel }}</label>
                  <input v-model="vmWrkAgentFormData.agent_name" type="text" class="form-control" required/>
                </div>

                <!-- Agent Description -->
                <div class="col-md-12 mb-3">
                  <label>{{ cvAgentDescLabel }}</label>
                  <b-form-textarea
                    v-model="vmWrkAgentFormData.agent_desc"
                    rows="6"
                    max-rows="12"
                    placeholder="Enter Agent Description..."
                    required
                  />
                </div>

                <!-- Module Name -->
                <div class="col-md-12 mb-3">
                  <label>{{ cvModuleNameLabel }}</label>
                  <select
                    v-model="vmWrkAgentFormData.module_name"
                    class="form-control"
                    required
                  >
                    <option value="" disabled>Select Module</option>
                    <option v-for="(module, index) in propModules" :key="index" :value="module.mod_name">{{ module.mod_name }}</option>
                  </select>
                </div>

                <!-- Action -->
                <div class="col-md-12 mb-3">
                  <label>{{ cvActionLabel }}</label>
                  <b-form-textarea
                    v-model="vmWrkAgentFormData.action"
                    rows="4"
                    max-rows="8"
                    placeholder="Schedule counseling session, stream-selection, career-selection"
                    required
                  />
                </div>

                <!-- App Domain -->
                <div class="col-md-12 mb-3">
                  <label>{{ cvAppDomainLabel }}</label>
                  <input v-model="vmWrkAgentFormData.agent_app_domain" type="text" class="form-control" required/>
                </div>

                <button
                  :disabled="cvLoadingStatus"
                  type="button"
                  class="btn btn-primary mx-2"
                  @click="wrkAgentEdit()"
                >
                  {{ cvSubmitBtn }}
                </button>

              </div>
            </form>
          </template>
        </iq-card>
      </b-col>
    </b-row>

    <b-toast
      v-model="showToast"
      name="Toast"
      :auto-hide-delay="toastVariant === 'danger' ? 10000 : 1000"
      :variant="toastVariant"
      :title="toastTitle"
    >
      <div v-html="toastMsg"></div>
    </b-toast>
  </b-container>
</template>

<script>
import { socialvue } from "../../../config/pluginInit.js"
import { WrkAgentApiObj } from "../../../FackApi/api/wrkAgent.js"

export default {
  name: "wrkAgentEdit",
  props: {
    propOpenedInModal: {
      type: Boolean,
      default: false
    },
    propWrkAgentObj: {
      type: Object,
      default: function () {
        return {
          agent_id: "",
          agent_name: "",
          agent_desc: "",
          module_name: "",
          action: "",
          agent_app_domain: ""
        }
      }
    },
    propModules: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      cvCardTitle: "Edit Agent",
      cvSubmitBtn: "Edit",
      cvAgentIdLabel: "Agent Id",
      cvAgentNameLabel: "Agent Name",
      cvAgentDescLabel: "Agent Description",
      cvModuleNameLabel: "Module Name",
      cvActionLabel: "Action",
      cvAppDomainLabel: "App Domain",
      showToast: false,
      toastMsg: null,
      toastVariant: "default",
      toastTitle: "Agent",
      cvLoadingStatus: false,
      vmWrkAgentFormData: {}
    }
  },
  computed: {
    userData () {
      return this.$store.getters["User/userData"]
    }
  },
  mounted () {
    socialvue.index()
    if (this.propOpenedInModal && this.propWrkAgentObj && Object.keys(this.propWrkAgentObj).length) {
      this.vmWrkAgentFormData = Object.assign({}, this.propWrkAgentObj)
    }
    else if (!this.propOpenedInModal) {
      const agentId = this.$route.params.agent_id
      if (agentId) {
        this.wrkAgentView(agentId)
      }
    }
  },
  methods: {
    /**
     * validate
     */
    validate () {
      try {
        for (let index in this.vmWrkAgentFormData) {
          const value = this.vmWrkAgentFormData[index]
          if (!String(value || "").trim()) {
            if (index === "agent_app_domain") {
              this.toastMsg = "Missing App Domain"
            }
            else {
              this.toastMsg = "Missing " + index.split("_").join(" ")
            }
            this.toastVariant = "danger"
            this.showToast = true
            return false
          }

          if (index === "agent_app_domain") {
            const domainRegex = /^[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
            if (!domainRegex.test(this.vmWrkAgentFormData[index])) {
              this.toastMsg = "Please enter a valid domain"
              this.toastVariant = "danger"
              this.showToast = true
              return false
            }
          }
        }

        return true
      }
      catch (err) {
        console.error("Exception occurred at validate() and Exception:", err.message)
      }
    },
    /**
     * wrkAgentEdit
     */
    async wrkAgentEdit () {
      if (!this.validate()) {
        return false
      }

      try {
        this.cvLoadingStatus = true

        let wrkAgentEditResp = await WrkAgentApiObj.wrkAgentEdit(this, this.vmWrkAgentFormData)
        if (wrkAgentEditResp && !wrkAgentEditResp.resp_status) {
          this.toastMsg = wrkAgentEditResp.resp_msg || "Failed to edit agent"
          this.toastVariant = "danger"
          this.showToast = true
          return false
        }

        this.toastMsg = "Agent updated successfully"
        this.toastVariant = "success"
        this.showToast = true

        if (this.propOpenedInModal) {
          this.$emit("emitCloseWrkAgentEditModal")
        }
        else {
          setTimeout(() => {
            this.wrkAgentView(this.vmWrkAgentFormData.agent_id)
          }, 500)
        }
      }
      catch (err) {
        console.error("Exception occurred at wrkAgentEdit() and Exception:", err.message)
        this.toastMsg = "Failed to edit agent"
        this.toastVariant = "danger"
        this.showToast = true
      }
      finally {
        this.cvLoadingStatus = false
      }
    },
    /**
     * wrkAgentView
     */
    async wrkAgentView (agentId) {
      try {
        let wrkAgentViewResp = await WrkAgentApiObj.wrkAgentView(this, agentId)
        if (wrkAgentViewResp && !wrkAgentViewResp.resp_status) {
          this.toastMsg = "Failed to fetch agent details"
          this.toastVariant = "danger"
          this.showToast = true
          return false
        }

        this.vmWrkAgentFormData = Object.assign({}, wrkAgentViewResp.resp_data.data)
      }
      catch (err) {
        console.error("Exception occurred at wrkAgentView() and Exception:", err.message)
      }
      finally {
        this.cvLoadingStatus = false
      }
    }
  }
}
</script>
